import CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import { LanguageRegionCode } from '@alltrails/core/types/LanguageRegionCode';
import { useLanguageRegionCode } from '@alltrails/language/hooks/useLanguageRegionCode';
import Image, { StaticImageData } from 'next/image';
import AppIcon from '@alltrails/denali/components/AppIcon';
import StarRating from '@alltrails/denali/components/StarRating';
import type DeeplinkData from '@alltrails/types/DeeplinkData';
import BaseInterstitialStep from '../BaseInterstitialStep';
import styles from './MiniVariant.module.scss';
import editorsChoiceEnUS from './images/apple-editors-choice-en-US.svg';
import editorsChoiceDaDk from './images/apple-editors-choice-da-DK.svg';
import editorsChoiceNlNl from './images/apple-editors-choice-nl-NL.svg';
import editorsChoiceEnGb from './images/apple-editors-choice-en-GB.svg';
import editorsChoiceFrFr from './images/apple-editors-choice-fr-FR.svg';
import editorsChoiceDeDe from './images/apple-editors-choice-de-DE.svg';
import editorsChoiceItIt from './images/apple-editors-choice-it-IT.svg';
import editorsChoiceNbNo from './images/apple-editors-choice-nb-NO.svg';
import editorsChoicePlPl from './images/apple-editors-choice-pl-PL.svg';
import editorsChoicePtPt from './images/apple-editors-choice-pt-PT.svg';
import editorsChoicePtBr from './images/apple-editors-choice-pt-BR.svg';
import editorsChoiceEsEs from './images/apple-editors-choice-es-ES.svg';
import editorsChoiceEsMx from './images/apple-editors-choice-es-MX.svg';
import editorsChoiceSvSE from './images/apple-editors-choice-sv-SE.svg';

type MiniVariantProps = {
  deeplinkData?: DeeplinkData;
  onCloseRequest: () => void;
  navigateToAuthStep: () => void;
  displayTrigger: CarouselDisplayTrigger;
};

const MiniVariant = ({ deeplinkData, onCloseRequest, navigateToAuthStep, displayTrigger }: MiniVariantProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const editorsChoiceImages: Record<LanguageRegionCode, StaticImageData> = {
    ['da-DK']: editorsChoiceDaDk,
    ['nl-NL']: editorsChoiceNlNl,
    ['en-GB']: editorsChoiceEnGb,
    ['en-US']: editorsChoiceEnUS,
    ['fr-FR']: editorsChoiceFrFr,
    ['de-DE']: editorsChoiceDeDe,
    ['it-IT']: editorsChoiceItIt,
    ['nb-NO']: editorsChoiceNbNo,
    ['pl-PL']: editorsChoicePlPl,
    ['pt-PT']: editorsChoicePtPt,
    ['pt-BR']: editorsChoicePtBr,
    ['es-ES']: editorsChoiceEsEs,
    ['es-MX']: editorsChoiceEsMx,
    ['sv-SE']: editorsChoiceSvSE
  };
  return (
    <BaseInterstitialStep
      deeplinkData={deeplinkData}
      onCloseRequest={onCloseRequest}
      navigateToAuthStep={navigateToAuthStep}
      displayTrigger={displayTrigger}
      contentsClassName={styles.modalContents}
    >
      <div className={styles.container}>
        <AppIcon size={60} />
        <Typography variant="heading400">
          <FormattedMessage defaultMessage="AllTrails is better in the app" />
        </Typography>

        <div className={styles.row}>
          <div className={styles.statsContainer}>
            <div className={styles.stats}>
              <div className={styles.rating}>
                <Typography variant="text200bold">
                  <FormattedNumber value={4.9} />
                </Typography>
                <StarRating rating={5} size="sm" />
              </div>
              <Typography color="tertiary" variant="text200">
                <FormattedMessage defaultMessage="1M+ reviews" />
              </Typography>
            </div>
          </div>
          <div className={styles.dividerContainer}>
            <div className={styles.divider} />
          </div>
          <div className={styles.award}>
            <Image src={editorsChoiceImages[languageRegionCode]} alt="" />
          </div>
        </div>
      </div>
    </BaseInterstitialStep>
  );
};

export default MiniVariant;
